
import HomePage from '../pages/home.vue';
import PriceViewPage from '../pages/price-view.vue';
import PricePage from '../pages/price.vue';
import ConfirmPage from '../pages/confirm.vue';
import OrderPage from '../pages/order.vue';
import HistoryPage from '../pages/history.vue';
import NotificationPage from '../pages/notification.vue';
import ProfilePage from '../pages/profile.vue';
import CarPage from '../pages/car.vue';
import RegistrationPage from '../pages/registration.vue';

import NotFoundPage from '../pages/404.vue';

var routes = [
  {
    path: '/',
    component: HomePage,
  },
  {
    path: '/registration/',
    component: RegistrationPage,
  },
  {
    path: '/start/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Resolve route to load page
      resolve(
        {
          component: ProfilePage,
        },
        {
          context: {
            start: true,
          }
        }
      );
    }
  },
  {
    path: '/price/',
    component: PricePage,
  },
  {
    path: '/price-view/',
    component: PriceViewPage,
  },
  {
    path: '/confirm/',
    component: ConfirmPage,
  },
  {
    path: '/order/:id/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Resolve route to load page
      resolve(
        {
          component: OrderPage,
        },
        {
          context: {
            id: routeTo.params.id,
          }
        }
      );
    },
  },
  {
    path: '/notification/',
    component: NotificationPage,
  },
  {
    path: '/history/',
    component: HistoryPage,
  },
  {
    path: '/profile/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Resolve route to load page
      resolve(
        {
          component: ProfilePage,
        },
        {
          context: {
            start: false,
          }
        }
      );
    }
  },
  {
    path: '/car/:method/:key/',
    async: function (routeTo, routeFrom, resolve, reject) {
      // Router instance
      var router = this;

      // App instance
      var app = router.app;

      // Show Preloader
      // app.preloader.show();

      // console.log(routeTo.params.method);


      // We got user data from request
      var car = {
        method: routeTo.params.method,
        key: routeTo.params.key,
      };
      // Hide Preloader
      // app.preloader.hide();

      // Resolve route to load page
      resolve(
        {
          component: CarPage,
        },
        {
          context: {
            car: car,
          }
        }
      );
    },
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
